import React from 'react';
import CMSFactory from "factories/CMS";
import PropTypes from 'prop-types';
import DoubleImage from 'components/School/BannerCategories/DoubleImage';
import SingleImage from 'components/School/BannerCategories/SingleImage';

const ItemsCategories = (props) => {
    const images = props.images;
    const dateServer = props.dateServer;

    const validateDates = (serverDate, element) => {
        let startDate = element.start_date ? CMSFactory.milliseconds(element.start_date) : '';
        let endDate = element.end_date ? CMSFactory.milliseconds(element.end_date) : '';
        if (startDate && (startDate >= serverDate)) return false;
        return !(endDate && (serverDate >= endDate));
    };

    return (
        <>
            {images && images.map((item, i) => {
                switch(item.acf_fc_layout) {
                    case 'single_image':

                        if (!validateDates(dateServer, item)) return '';
                        return (
                            <SingleImage item={item} key={i}/>
                        )
                        
                    case 'double_image':
                        if (!validateDates(dateServer, item)) return '';
                        return (
                            <DoubleImage item={item} key={i}/>
                        )
                }
            })}
        </>
    )
}

ItemsCategories.propTypes = {
    images: PropTypes.array,
    dateServer: PropTypes.number
};


export default ItemsCategories;
